
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import FilePathService from '@/apps/shared/services/filePath-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    export default Vue.extend({
        components: {
        },
        name: 'ElectronicDevicePayment',
        data() {
            return {
                rate: null,
                precioSinDescuento: null,
                capital: null,
                description: true,
                localItems: [{ text: 'Inicio', path: '/tecnologia' }],
            }
        },
        methods: {
            changeTitleAndIcon() {
                // Lógica para determinar el nuevo título
                const newTitle = 'Tecnología';
                // Emite eventos para actualizar el título
                this.$emit('updateTitle', newTitle);
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        window.location.href = response + "tecnologia";
                    });
            },

            getCUPE: function () {
                var email = "";
                var productId = 1000;
                NF.UI.Page.blockCustom({ message: "Redirigiendo al pago" });
                var timeStart = new Date().getTime();
                CUPEService.GetCUPEUrl(productId, email).then(response => {
                    document.getElementById("pagoIframe").setAttribute('src', response.preferenceMessage);
                    document.getElementById('pagoIframe').addEventListener('load', () => {
                        this.loadingIframe = false;
                        NF.UI.Page.unblock();
                        var endTime = new Date().getTime();
                        var secondCharge = Math.round((endTime - timeStart) / 1000);
                        window.globalThis.dataLayer.push({ 'product': 'tecnologia', 'event': 'cotizador-tecnologia-checkout', 'carga': secondCharge });
                        NF.UI.Page.unblock();
                    });

                })
            },

            open: function () {
                this.$refs.modal.open();
            },

            close: function () {
                this.$refs.modal.close();
            },
        },
        mounted() {
            this.changeTitleAndIcon();
            this.updateByProductGoogleAnalytics();
            this.getCUPE();
            var planDataSelected = sessionStorage.getItem("PlanSelected")
            var coverData = sessionStorage.getItem("cover");
            if (coverData != null) {
                this.cover = JSON.parse(coverData!)
                this.cobertura = this.cover
            }
            if (planDataSelected != null) {
                this.DataPlan = JSON.parse(planDataSelected!);
                this.planDescription = this.DataPlan.planDescription;
                this.primerCuota = this.DataPlan.premioMensual;
                this.capital = this.DataPlan.capital;
                this.precioSinDescuento = this.DataPlan.premiumWithoutDiscount;
                new Promise<any>(async (resolve) => {
                    DiscountRangeService.getElectronicEquipmentDiscountRange().then((response) => {
                        if (response.length > 0) {
                            this.responseDiscountRange = response;
                            this.rate = this.responseDiscountRange[0].discountMaxValue;
                            this.discountOff = this.responseDiscountRange[0].discountMaxValue;
                            resolve(true);
                            NF.UI.Page.unblock();
                        }
                    })
                })

            }
            sessionStorage.setItem("ExitOrContinueModal", "true")
        },
    });
